import Vue from "vue";
import { axios } from "./api.config";
Vue.prototype.$http = axios;

const Auth = {
  login: (params) => axios.post("/auth/login", params),
  register: (params) => axios.post("/auth/register", params),
  restoreAccount: (params) => axios.post("/auth/restore_account", params),
  forgotPassword: (params) =>
    axios.post("/auth/reset_password", params, { jwt: true }),
  checkResetToken: (params) =>
    axios.post("/auth/check_reset_token", params, { jwt: true }),
  setPassword: (params) => axios.post("/auth/set_password", params, params, { jwt: true }),
  oneClickAuth: (params) => axios.post("/auth/one_click_auth", params),
};

const User = {
  current: () => axios.get("/users/current", { jwt: true }),
  update: (params) => axios.put("/users", { user: params }, { jwt: true }),
  resendConfirmation: (params) =>
    axios.post("/users/resend_confirmation", params, { jwt: true }),
  sendLoginLink: (params) =>
    axios.post("/users/send_login_link", params, { jwt: true }),
  invite: (params) => axios.post(`/users/invite`, { user: params }, { jwt: true }),
};

const Page = {
  query: () => axios.get("/pages"),
};

const Schedule = {
  query: (params) => axios.get("/schedules", { params }),
};

const ArticleSection = {
  query: (params) => axios.get("/article_sections", { params }),
  article: (params) => axios.get("/article_sections/article", params),
};

const Article = {
  get: (params) => axios.get(`/articles/${params.id}`),
};

const Help = {
  create: (params) => axios.post(`/help`, params),
};

const Support = {
  create: (params) => axios.post(`/support`, params),
};

const EmailSubscription = {
  create: (params) => axios.post(`/email_subscriptions`, params),
};

const Event = {
  query: (params) => axios.get("/events", { params }),
};

const Message = {
  query: (params) => axios.get("/messages", { params }),
  destroy: (id) => axios.delete(`/messages/${id}`, { jwt: true }),
  destroyAll: (params) => axios.delete(`/messages`, { params, jwt: true }),
  blockUser: (params) =>
    axios.delete(`/messages/block_user`, { params, jwt: true }),
};

const Countdown = {
  query: (params) => axios.get("/countdowns", { params }),
};

const Memory = {
  query: (params) => axios.get("/memories", { params }),
  create: (params, { onUploadProgress }) =>
    axios.post("/memories", params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      jwt: true,
      onUploadProgress: (progressEvent) => {
        const loaded = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        return onUploadProgress(loaded);
      },
    }),
};

const Contact = {
  query: (params) => axios.get("/contacts", { params }),
  create: (params, { onUploadProgress }) =>
    axios.post("/contacts", params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      jwt: true,
      onUploadProgress: (progressEvent) => {
        const loaded = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        return onUploadProgress(loaded);
      },
    }),
};

const Chat = {
  get: (params) => axios.get("/chats", { params }),
  messages: (params) => axios.get("/chats/messages", { params }),
};

const Donor = {
  query: (params) => axios.get("/donors", { params }),
};

const Speaker = {
  query: (params) => axios.get("/speakers", { params }),
};

const Question = {
  create: (params) => axios.post(`/questions`, params),
};

Vue.prototype.$api = {
  Auth,
  User,
  Page,
  Chat,
  Event,
  Countdown,
  ArticleSection,
  Article,
  Message,
  Memory,
  Help,
  Support,
  Schedule,
  EmailSubscription,
  Donor,
  Contact,
  Speaker,
  Question,
};
